import React, { useState, useEffect } from 'react';
import numWords from 'num-words'; // Library to convert numbers to words
import img from '../../assets/images/report-icon.jpg'

const UpdatedReport = ({ reportDataUpdated }) => {
  // Ensure all values are numbers for calculation
  const totalFeeAmount = reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.remainingAmount || 0), 0);
  const totalPaidFee = reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.payAmount || 0), 0);
  const totalBeforePay = reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.beforePay || 0), 0);
  const totalRemainingAmount = totalFeeAmount - (totalBeforePay );
  const udiseNumber = localStorage.getItem("udiseNumber");
  const discountAmountTotal = reportDataUpdated.feeDetails.reduce((acc, fee) => acc + parseFloat(fee.discountAmount || 0), 0);

  const remainingFeeInWords = numWords(totalRemainingAmount); // Convert remaining amount to words


  const language = localStorage.getItem("language");
  const [schoolDetails, setSchoolDetails] = useState({});
  const fetchSchoolDetails = async (udiseNumber) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/schoolData.json`);
      const data = await response.json();
      console.log('Fetched school details:', data);
      return data || {}; // Return the fetched data or an empty object if null
    } catch (error) {
      console.error('Error fetching school details:', error);
      return {};
    }
  };

  useEffect(() => {
    const fetchSchoolData = async () => {
      if (udiseNumber) {
        const details = await fetchSchoolDetails(udiseNumber);
        setSchoolDetails(details);
      }
    };

    fetchSchoolData();
  }, [udiseNumber]);

  const generateHtmlReport = () => {
    const feeDetailsRows = reportDataUpdated.feeDetails.map((fee, index) => `
      <tr>
        <td>${index + 1}</td>
        <td>${fee.feetype}</td>
        <td>${parseFloat(fee.remainingAmount || 0).toFixed(2)}</td>
        <td>${parseFloat(fee.payAmount || 0).toFixed(2)}</td>
      </tr>
    `).join('');
  
    const htmlContent = ` 
      <html>
        <head>
          <style>
            body { font-family: Arial, sans-serif; margin: 0; padding: 0; } 
            .receipt-container { width: 100%; display: flex; justify-content:flex-start;  gap: 30px; }
            .receipt { width: 80%; border: 1px solid black; padding: 20px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); box-sizing: border-box;   height: 700px;}
          .title { text-align: center; background-color: black; color: white; padding: 5px 0; margin-bottom: 10px; width: 150px; margin-left:170px}
            .details { margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 10px; }
            th, td { border: 1px solid black; padding: 10px; text-align: left; }
            th { background-color: #f2f2f2; }
            .footer { margin-top: 210px; }
            .signature { float: right; margin-top: 20px; }
            @media print {
               @page {
             size: A4 Landscape;
            margin:3mm; 
          }
              .receipt { page-break-after: always; }
              .signature { float: none; margin-top: 5px; }
            }
          </style>
        </head>
        <body>
          <div class="receipt-container">
            <div class="receipt">
              <div style="border: 1px solid black; margin-bottom: 10px; background-color: #F7F7F7; padding: 10px;">
                <h6 style="text-align: center; margin: 0;">${schoolDetails.sansthaName || 'N/A'}</h6>
                <h3 style="text-align: center; margin: 0;">${schoolDetails.schoolName || 'N/A'}</h3>
              </div>
              <div class="title">Office Fee Receipt</div>
              <div style="border: 1px solid black; margin-bottom: 10px; background-color: #F7F7F7; padding: 5px;">
                <p style="margin: 0;">Invoice No: ${reportDataUpdated.pavatiNo}&nbsp;&nbsp;Year: ${reportDataUpdated.year}&nbsp;&nbsp;Date: ${reportDataUpdated.date}</p>
              </div>
              <div class="details">
                <h7 style="margin: 0;">Student Name: ${reportDataUpdated.studentName}</h7>
                <div style="font-size: 14px; margin-top: 5px;">
                  <p style="margin: 0;">Class: ${reportDataUpdated.studentClass}&nbsp;&nbsp;Division: ${reportDataUpdated.division}&nbsp;&nbsp;Register No: ${reportDataUpdated.registerNo}</p>
                </div>
              </div>
                <p style="margin: 10px;">Total Discount: Rs. ${discountAmountTotal}</p>
              <table>
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Fee Type</th>
                    <th>Fee Amount</th>
                    <th>Paid Fee</th>
                  </tr>
                </thead>
                <tbody>
                  ${feeDetailsRows}
                  <tr>
                    <td colspan="2">Total</td>
                    <td>${totalFeeAmount.toFixed(2)}</td>
                    <td>${totalPaidFee.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td colspan="2">Before Pay: ${totalBeforePay.toFixed(2)}</td>
                    <td colspan="2">Remaining Fee: ${totalRemainingAmount.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
                <p>Remaining Fee (in words): ${remainingFeeInWords}</p>
              <div class="footer">
              
                <p class="signature">Signature:</p>
              </div>
            </div>

                <div class="receipt">
              <div style="border: 1px solid black; margin-bottom: 10px; background-color: #F7F7F7; padding: 10px;">
                <h6 style="text-align: center; margin: 0;">${schoolDetails.sansthaName || 'N/A'}</h6>
                <h3 style="text-align: center; margin: 0;">${schoolDetails.schoolName || 'N/A'}</h3>
              </div>
              <div class="title">Student Fee Receipt</div>
              <div style="border: 1px solid black; margin-bottom: 10px; background-color: #F7F7F7; padding: 5px;">
                <p style="margin: 0;">Invoice No: ${reportDataUpdated.pavatiNo}&nbsp;&nbsp;Year: ${reportDataUpdated.year}&nbsp;&nbsp;Date: ${reportDataUpdated.date}</p>
              </div>
              <div class="details">
                <h7 style="margin: 0;">Student Name: ${reportDataUpdated.studentName}</h7>
                <div style="font-size: 14px; margin-top: 5px;">
                  <p style="margin: 0;">Class: ${reportDataUpdated.studentClass}&nbsp;&nbsp;Division: ${reportDataUpdated.studentDivision}&nbsp;&nbsp;Register No: ${reportDataUpdated.registerNo}</p>
                
                </div>
                
              </div>
                <p style="margin: 10px;">Total Discount: Rs. ${discountAmountTotal}</p>
              <table>
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>Fee Type</th>
                    <th>Fee Amount</th>
                    <th>Paid Fee</th>
                  </tr>
                </thead>
                <tbody>
                  ${feeDetailsRows}
                  <tr>
                    <td colspan="2">Total</td>
                    <td>${totalFeeAmount.toFixed(2)}</td>
                    <td>${totalPaidFee.toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td colspan="2">Before Pay: ${totalBeforePay.toFixed(2)}</td>
                    <td colspan="2">Remaining Fee: ${totalRemainingAmount.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
              <p>Remaining Fee (in words): ${remainingFeeInWords}</p>
              <div class="footer">
                
                <p class="signature">Signature:</p>
              </div>
            </div>



          </div>

        </body>
      </html>
    `;
  
    // Open a new window and write the HTML content
    const newWindow = window.open('', '_blank');
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  
    // Wait for the content to load before triggering the print
    newWindow.focus();
    newWindow.print();
  
    // Optionally close the window after printing
    newWindow.onafterprint = function() {
      newWindow.close();
    };
  };
  
  // Print Button
  const PrintButton = () => {
    return (
      <button onClick={generateHtmlReport} style={{ padding: '10px 15px', fontSize: '16px', cursor: 'pointer', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '5px' }}>
        Print Report
      </button>
    );
  };
  
  // Usage
  <PrintButton />
  

  return (
    <div>
      <img
        src={img}
        style={{ width: '60px', height: 'auto', cursor: 'pointer' }}
        onClick={generateHtmlReport}
        title="Quick Receipt"
      />
    </div>
  );
};

export default UpdatedReport;
